<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title">{{badgeTitle}}</div>

</ion-header>

<ion-content class="ion-padding" no-bounce>
  <div class="leada-badge" [ngClass]="badgeClass">
    <badge-image [badge]="badge"></badge-image>
    <rich-text [text]="badgeDescription"></rich-text>
  </div>
  <ng-template [ngIf]="userBadge">
    <div class="result" translate [translateParams]="{datum: userBadgeDatum}">
      BADGE.RESULT
    </div>
  </ng-template>
  <ng-template [ngIf]="!userBadge">
    <div class="open-challenge" translate>
      BADGE.OPENCHALLENGE
    </div>
  </ng-template>
</ion-content>

